/* eslint-disable arrow-parens */
import { StatusCodes } from "http-status-codes";
import { request } from "../../api";
import { headers } from "../../../../config/config";
import { MESSAGE } from "../../../../constants/api/message";
import { AUTHORIZATION } from "../../../../constants/api/auth";
const { post, get, patch } = request;
const { Authorization, Bearer } = AUTHORIZATION;

const initialRoute = "auth";

export const forgetUserName = async (_payload) => {
	try {
		const payload = JSON.stringify(_payload);
		const endpoint = `${initialRoute}/forget-user-name`;
		const response = await post(endpoint, _payload, headers);

		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.post.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
	} catch (error) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;
			if (message === "Incorrect Type Provided") {
				alert("Incorrect Type Provided");
			} else if (message === MESSAGE.none) {
				alert("No Such Data!");
			} else if (message === MESSAGE.post.fail) {
				alert("Failed to Send User Id to Mail!");
			} else alert("Other Errors of Status Code 400");
		} else if (error.response.status === StatusCodes.NOT_FOUND) {
			const { message } = error.response.data;

			if (message === "No User found with given information!") {
				alert("No User found with given information!");
				// throw error;
			} else {
				throw error;
				//alert("Other Errors of Status Code 401");
			}
		} else {
			throw error;
		}
	}
};
